import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import seed from '../assets/images/seed.svg';
import halawa from '../assets/images/rahash.png'
import cookies from '../assets/images/imgs/cookies.png'
import tahina from '../assets/images/imgs/tahina.png'
import chocolate from '../assets/images/imgs/chocolate.png'
import maamoul from '../assets/images/imgs/maamoul.png'
import { useNavigate } from "react-router-dom";
export default function Seed() {
    const { t } = useTranslation();
    const navigate = useNavigate()
    const seedSection = useRef()
    const pinnedSeedRef = useRef()

    useEffect(() => {
        document.body.className = '';
        document.body.classList.add('brands');
    }, [])

    window.onscroll = () => {

        if (seedSection.current.getBoundingClientRect().top < 20 && seedSection.current.getBoundingClientRect().top > -(seedSection.current.getBoundingClientRect().height - 280)) {
            pinnedSeedRef.current.classList.add('fixed')
        } else {
            pinnedSeedRef.current.classList.remove('fixed')
        }
    }
    return (
        <section className="relative flex gap-[20px] p-[20px] lg:p-[100px]" ref={seedSection}>
            <div className="w-[80px] min-w-[80px] lg:w-[150px] lg:min-w-[150px] relative">
                <div onClick={()=>navigate(-1)} ref={pinnedSeedRef} className="z-[999] top-[120px] bg-white border-[#D0A847] border-[2px] w-[80px] min-w-[80px] h-[80px] lg:w-[150px] lg:min-w-[150px] lg:h-[150px] flex items-center justify-center rounded-[10px] transition-all duration-700 cursor-pointer">
                    <img src={seed} className="w-[50px] min-w-[50px] lg:w-[100px] lg:min-w-[100px]" alt="" />
                </div>
            </div>
            <div className="flex flex-col gap-[20px] px-[0px] lg:px-[100px]">
                <h1 className="text-[#D0A847] text-xl lg:text-3xl 2xl:text-6xl underline capitalize underline-offset-[12px] decoration-[2px] nc">{t('al_seedawi')}</h1>
                <h2 className="capitalize text-md lg:text-xl nc">{t('al_seedawi_desc')}</h2>
                <div className="flex flex-col gap-[50px] nc">
                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('halawa')}</h3>
                    <img src={halawa} className="w-full lg:w-3/4 m-auto" alt="" />

                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('oat_cookies')}</h3>
                    <img src={cookies} className="w-full lg:w-3/4 m-auto" alt="" />

                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('premium_chocolate')}</h3>
                    <img src={chocolate} className="w-full lg:w-3/4 m-auto" alt="" />

                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('tahina')}</h3>
                    <img src={tahina} className="w-full lg:w-3/4 m-auto" alt="" />

                    <h3 className="underline text-lg lg:text-2xl 2xl:text-4xl nc">{t('maamoul')}</h3>
                    <img src={maamoul} className="w-full lg:w-3/4 m-auto" alt="" />
                </div>
            </div>
        </section>
    )
}